export default "__VITE_ASSET__36b4371c__"